import { Row } from 'antd'
import Flex from 'components/Flex'
import styled from 'styled-components'
import { COLORS } from 'theme'

export const PlacementFlex = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100vh - 142px);
  overflow: scroll;
  padding-right: 10px;
  ::-webkit-scrollbar {
    width: 8px;
  }
  ::-webkit-scrollbar-thumb {
    background: #999;
    border-radius: 50px;
  }
`
export const FolderDiv = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  gap: 2rem;
  margin-top: 2rem;
`

export const LeftSection = styled(Flex)`
  gap: 20px;
`

export const JobRoleFlex = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 1.5rem;
  flex-wrap: wrap;
`

export const RightSection = styled(Flex)`
  justify-content: flex-end;
  gap: 20px;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: flex-end;
`
export const StudentCount = styled.div`
  display: flex;
  justify-content: end;
  margin-top: 1em;
`
export const TopHeading = styled(Flex)`
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  color: #4d566e;
`

export const FilterText = styled.p`
  margin-bottom: 0;
  margin-left: 10px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${COLORS.GREY_T_60};
  display: flex;
  align-items: baseline;
  justify-content: center;
`
export const FullWidthRow = styled(Row)`
  width: 100%;
  align-items: center;
`

export const FolderWholeDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
  width: 120px;
`

export const TextBold = styled.span`
  font-size: 12px;
  font-weight: 700;
  line-height: initial;
  text-align: center;
`

export const BatchHead = styled.h1`
  margin: 4rem 0rem 0.5rem;
  font-size: 20px;
  font-weight: 600;
`
export const FilterGap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-top: 2.5rem;
`

export const FolderSpinner = styled.div`
  justify-content: center;
  display: flex;
  width: 100%;
`

export const FilterFolderRelative = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`
export const FilterFolderAbsolute = styled.div`
  z-index: 9;
  font-weight: 600;
  font-size: 14px;
  width: 100%;
  color: ${props => props.disabled && '#939393'};
`
export const FilterAlignWhole = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
`

export const FilterAlignInner = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  justify-content: space-between;
`

export const FolderTableName = styled.div`
  font-size: ${props => (props.fontsize ? props.fontsize : '')};
  font-weight: 600;
  color: ${props => (props.color ? props.color : '')};
  cursor: pointer;
`
export const FolderTableNameFlex = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`
export const NoDataStyle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: auto;
  padding-top: 4rem;
  text-align: center;
`
export const NoDataContent = styled.p`
  line-height: initial;
  font-size: 1.1rem;
  font-weight: 600;
  color: #808697;
  margin-top: -1rem;
`

export const PlacementCursor = styled.div`
  cursor: ${props => (props.cursor ? 'pointer' : 'auto')};
`

export const LetterBold = styled.span`
  color: #3249d7;
  font-weight: 700;
  cursor: pointer;
`

export const TableEllipse = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
export const TableShowJobButton = styled.button`
  border: 1px solid #3249d7;
  background: #ebecf8;
  color: #3249d7;
  font-weight: 600;
  padding: 4px 15px;
  height: 40px;
  display: flex;
  align-items: center;
  border-radius: 8px;
  cursor: pointer;
`

export const ButtonFlex = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
`
export const FolderHeading = styled.h3`
  text-transform: capitalize;
  margin-top: 10px;
  font-size: 1.1rem;
  margin-right: 1rem;
`
export const FilterCol1 = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`

export const MultiPadding = styled.div`
  padding: 1rem 0px;
  display: flex;
  gap: 1rem;
  align-items: center;
`
export const BoldText = styled.p`
  font-weight: bold;
  width: max-content;
  margin-top: 5px;
`
export const ImageAvatar = styled.img`
  border-radius: 50%;
  width: 35px;
  height: 35px;
`

export const SubmitFlex = styled(Flex)`
  gap: 20px;
  padding: 20px;
  border-top: 1px solid ${COLORS.GREY_T_90};
`
export const MenuFlex = styled(Flex)`
  background: ${COLORS.WHITE};
  box-shadow: 0px 2px 6px rgba(123, 97, 255, 0.15);
`
export const RightSideSection = styled(Flex)`
  justify-content: flex-end;
  gap: 20px;
  flex-wrap: wrap;
  align-items: flex-end;
`

export const DownloadButton = styled.div`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
 border-radius: 6px;
transition: background 0.2s ease;
`


export const SelectAllFlex = styled.div`
  display: flex;
  align-items: center;
  border-radius: 4px;
`
